const FulfillmentState = require('@/lib/Kitchen/FulfillmentState');
/**
 * @param {OrderFulfillment[]} fulfillments
 *
 * @return {string}
 */
const calculateFulfillmentState = (fulfillments) => {
    const numFulfillments = fulfillments.length;
    const numFulfilledFulfillments = fulfillments.filter((f) => f.isFulfilled()).length;
    const numPartFulfilledFulfillments = fulfillments.filter((f) => {
        return !f.isFulfilled() && f.fulfilledItems.length > 0;
    }).length;

    if (numFulfilledFulfillments === 0 && numPartFulfilledFulfillments === 0) {
        return FulfillmentState.UNFULFILLED;
    }
    if (numFulfilledFulfillments > 0 && numFulfilledFulfillments === numFulfillments) {
        return FulfillmentState.FULFILLED;
    }
    return FulfillmentState.PART_FULFILLED;
};

module.exports = {
    calculateFulfillmentState,
};
